import React from "react";
import logo from "../../../Assets/AppComponent/Qpms/White_logo.png";
import toppart from "../../../Assets/AppComponent/TopPartImg/Vector.png";
import Arrow from "../../../Assets/AppComponent/Arrow/Frame.png";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import "../../../StyleSheet/MainComponent/ResetPassword/ResetPassword.scss";
import validator from "validator";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Text from "../../AppComponent/InputFields/Text";
import Repassword from "../../AppComponent/InputFields/RePasswod/Repassword";
import { getUpdatedPasswordActions } from "../../../Redux/Slice";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import data from "../../../Json/Language/English";
import hindiDatas from "../../../Json/Language/Hinid";
import { useNavigate } from "react-router-dom";

const SetnewPassword = () => {
  const [label, setLabel] = useState("New Password ");
  const [label2, setalbel] = useState("Confirm Password");
  const State = useSelector((State) => State);
  const EnglishData = data;
  const HindiData = hindiDatas;

  const Datas = {
    password: "",
    repassword: "",
  };
  const [InputData, setInputDatas] = useState(Datas);
  const [PasswordEr, SetpasswordError] = useState("");
  const [RePasswordError, setRePasswordError] = useState("");
  const HandleChanges = (e) => {
    setInputDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };
   const navigate = useNavigate()

  const dispatch = useDispatch();
  const handleSubmit = () => {
    var a = 0;
    if (validator.isEmpty(InputData.password)) {
      SetpasswordError("*Enter New Password");
      a = 1;
    }

    if (validator.isEmpty(InputData.repassword)) {
      setRePasswordError("*password is required");
      a = 1;
    }
    if (InputData.password != InputData.repassword) {
      toast(` ${"password doesn't match"} `, {
        position: toast.POSITION.BOTTOM_LEFT,
      });
    }
    if (a == 0 && InputData.password == InputData.repassword) {
      dispatch(getUpdatedPasswordActions(InputData , navigate("/")));
    }
  };

  return (
    <>
      <div className="uds-RestartPassword">
        <div className=" row Conatiningpart">
          <div className="col-md-6 Welcomepart">
            {/* <div className="Toppart">
              <img className="desingimg" src={toppart} />
            </div> */}
            <div className="bottompart">
              <div className="leftSidepart">
                <div className="Logo">
                  <img className="logoUds" src={logo} />
                </div>
                {/* <div className='Content'>
                                    <h1>WELCOME</h1>
                                  
                                </div> */}
                {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Welcome.map((item) => (
                      <div className="   Content" id={item.id}>
                        <h1 key={item.id}>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {HindiData.LeftSide.Welcome.map((item) => (
                      <div className="   Content" id={item.id}>
                        <h1 key={item.id}>{item.Heading}</h1>
                      </div>
                    ))}
                  </>
                )}

                {/* <p className='reset'>Reset Your Password</p> */}
                {/* {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Content.ContentPassword.map(
                      (item) => (
                        <p className="reset" key={item.id}>
                          {item.para1}
                        </p>
                      )
                    )}
                  </>
                ) : (
                  <>
                    {hindiDatas.LeftSide.Content.ContentPassword.map((item) => (
                      <p className="reset" key={item.id}>
                        {item.para1}
                      </p>
                    ))}
                  </>
                )} */}

                {/* 
                                <div className='para'>                   
                                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting  industry.
                                    Lorem Ipsum has been the industry's standard dummy text ever </p>
                                </div> */}

                {/* {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.Content2.map((item) => (
                      <div className="para">
                        <p key={item.id}>{item.para2}</p>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {hindiDatas.LeftSide.Content2.map((item) => (
                      <div className="para">
                        <p key={item.id}>{item.para2}</p>
                      </div>
                    ))}
                  </>
                )} */}

                {/* --------Details-------------------- */}
                {/* <div className="Details">
                  {State.Language.Language == "EnglContentPasswordish" ? (
                    <>
                      {EnglishData.LeftSide.Details.Details5.map((item) => (
                        <p key={item.id}>{item.Details}</p>
                      ))}
                    </>
                  ) : (
                    <>
                      {hindiDatas.LeftSide.Details.Details5.map((item) => (
                        <p key={item.id}>{item.Details}</p>
                      ))}
                    </>
                  )}

                  <div className="Arrow">
                    <img src={Arrow} />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-6 loginpart">
            <div className="Loginwrapped">
              <div className="UdsRESET">
                {State.Language.Language == "English" ? (
                  <>
                    {EnglishData.LeftSide.NewPasswordSET.Header.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.Header}
                      </h4>
                    ))}
                  </>
                ) : (
                  <>
                    {hindiDatas.LeftSide.NewPasswordSET.Header.map((item) => (
                      <h4 className="heading" key={item.id}>
                        {item.Header}
                      </h4>
                    ))}
                  </>
                )}

                {/* <h4 className='heading'>Reset Your Password</h4> */}
                <div className="Input-Inner">
                  {/* --------Otp---Verify-------------------------- */}

                  {State.Language.Language == "English" ? (
                    <>
                      {EnglishData.LeftSide.NewPasswordSET.Label1.map(
                        (item) => (
                          <>
                            <Text
                              label={item.Label}
                              value={InputData.password}
                              onChange={(e) => {
                                SetpasswordError("");
                                HandleChanges(e);
                              }}
                              Error={PasswordEr}
                              name={"password"}
                            />
                            <Repassword
                              value={InputData.repassword}
                              onChange={(e) => {
                                setRePasswordError("");
                                HandleChanges(e);
                              }}
                              Error={RePasswordError}
                              label={item.Label2}
                              name={"repassword"}
                            />
                          </>
                        )
                      )}
                    </>
                  ) : (
                    <>
                      {hindiDatas.LeftSide.NewPasswordSET.Label1.map((item) => (
                        <>
                          <Text
                            label={item.Label}
                            value={InputData.password}
                            onChange={(e) => {
                              SetpasswordError("");
                              HandleChanges(e);
                            }}
                            Error={PasswordEr}
                            name={"password"}
                          />
                          <Repassword
                            value={InputData.repassword}
                            onChange={(e) => {
                              setRePasswordError("");
                              HandleChanges(e);
                            }}
                            Error={RePasswordError}
                            label={item.Label2}
                            name={"repassword"}
                          />
                        </>
                      ))}
                    </>
                  )}
                </div>
              </div>

              {State.Language.Language == "English" ? (
                <>
                  {EnglishData.LeftSide.Button.Button1.map((item) => (
                    <div className="SubmitButtons">
                      <CustomButton
                        children="Submit"
                        key={item.id}
                        type="submit"
                        className="ButtonCSS"

                        onClick={handleSubmit}
                      >
                        {item.ButtonName}
                      </CustomButton>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {HindiData.LeftSide.Button.Button1.map((item) => (
                    <div className="SubmitButtons">
                      <CustomButton
                        children="Submit"
                        type="submit"
                        key={item.id}
                        className="ButtonCSS"

                        onClick={handleSubmit}
                      >
                        {item.ButtonName}
                      </CustomButton>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SetnewPassword;
